// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cards_sectionCards__rZ-xG{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
}
.Cards_sectionCardsContainer__1Jc7w{
    display: flex;
    align-items: center;
    width: 100%;
    /* max-width: 1110px; */
    max-width: 2300px;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.Cards_card__ybewp{
    max-width: 405px;
    min-width: 330px;
    background-color: #fff;
    border-radius: var(--border-radius-lg);
    padding: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.Cards_card__ybewp img{
    width: 330px;
    /* width: 100%; */
    height: auto;
    object-fit: cover;
}
.Cards_card__ybewp h3{
    font-size: var(--font-size-lg);
    font-weight: var(--font-bold);
    margin: 0;
    text-align: center;
    color: var(--color-background);
    height: 54px;
}
.Cards_card__ybewp p{
    font-size: var(--font-size-lg);
    font-weight: var(--font-regular);
    color: var(--color-background);
    margin: 0;
    text-align: center;
    height: 120px;
}
.Cards_card__ybewp span{
    font-size: var(--font-size-xl);
    font-weight: var(--font-regular);
    color: var(--color-background);
    margin: 0;
    text-align: center;
    
}
.Cards_price__5p-fO{
    padding: 20px;
}

/* Стили для карусели */
.Cards_carouselContainer__r7iHE {
  position: relative;
  width: 100%;
}

/* Видимая область карусели */
.Cards_carouselViewport__Ew4wB {
  overflow: hidden;
  width: 100%;
  position: relative;
}

/* Контейнер с карточками */
.Cards_cardsWrapper__tGoOy {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

/* Режим карусели */
.Cards_carousel__GZWZk {
  flex-wrap: nowrap;
  transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);
  will-change: transform;
  justify-content: flex-start;
}

/* Карточка в карусели */
.Cards_carouselCard__5Mh-G {
  flex-shrink: 0;
  flex-grow: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
  margin-top: 50px;
}

/* Кнопки карусели */
.Cards_carouselButton__EIxLo {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  background-color: var(--color-header, #fff);
  color: var(--color-text-primary, #333);
  /* border: 1px solid var(--color-border, #e0e0e0); */
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 20px;
}

.Cards_carouselButton__EIxLo:hover {
  background-color: var(--color-accent, #f8f8f8);
  transform: translateY(-50%) scale(1.05);
}

.Cards_carouselButton__EIxLo:active {
  transform: translateY(-50%) scale(0.95);
}

.Cards_prevButton__nmblu {
  left: -18px;
}

.Cards_nextButton__U9ibW {
  right: -18px;
}

/* Анимации для кнопок */
@keyframes Cards_pulse__1RqEr {
  0% {
    transform: translateY(-50%) scale(1);
  }
  50% {
    transform: translateY(-50%) scale(1.05);
  }
  100% {
    transform: translateY(-50%) scale(1);
  }
}

/* Медиа-запросы для адаптивности */
@media (max-width: 768px) {
  .Cards_carouselButton__EIxLo {
    width: 30px;
    height: 30px;
  }
  
  .Cards_prevButton__nmblu {
    left: -10px;
  }
  
  .Cards_nextButton__U9ibW {
    right: -10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CardsUI/Cards/Cards.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;IACtC,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;;AAEtB;AACA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,wDAAwD;EACxD,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,2CAA2C;EAC3C,sCAAsC;EACtC,oDAAoD;EACpD,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE;IACE,oCAAoC;EACtC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".sectionCards{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 20px;\n    width: 100%;\n}\n.sectionCardsContainer{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    /* max-width: 1110px; */\n    max-width: 2300px;\n    gap: 20px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n}\n.card{\n    max-width: 405px;\n    min-width: 330px;\n    background-color: #fff;\n    border-radius: var(--border-radius-lg);\n    padding: 10px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n.card img{\n    width: 330px;\n    /* width: 100%; */\n    height: auto;\n    object-fit: cover;\n}\n.card h3{\n    font-size: var(--font-size-lg);\n    font-weight: var(--font-bold);\n    margin: 0;\n    text-align: center;\n    color: var(--color-background);\n    height: 54px;\n}\n.card p{\n    font-size: var(--font-size-lg);\n    font-weight: var(--font-regular);\n    color: var(--color-background);\n    margin: 0;\n    text-align: center;\n    height: 120px;\n}\n.card span{\n    font-size: var(--font-size-xl);\n    font-weight: var(--font-regular);\n    color: var(--color-background);\n    margin: 0;\n    text-align: center;\n    \n}\n.price{\n    padding: 20px;\n}\n\n/* Стили для карусели */\n.carouselContainer {\n  position: relative;\n  width: 100%;\n}\n\n/* Видимая область карусели */\n.carouselViewport {\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}\n\n/* Контейнер с карточками */\n.cardsWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n}\n\n/* Режим карусели */\n.carousel {\n  flex-wrap: nowrap;\n  transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1);\n  will-change: transform;\n  justify-content: flex-start;\n}\n\n/* Карточка в карусели */\n.carouselCard {\n  flex-shrink: 0;\n  flex-grow: 0;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 50px;\n  margin-top: 50px;\n}\n\n/* Кнопки карусели */\n.carouselButton {\n  position: absolute;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  background-color: var(--color-header, #fff);\n  color: var(--color-text-primary, #333);\n  /* border: 1px solid var(--color-border, #e0e0e0); */\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin: 20px;\n}\n\n.carouselButton:hover {\n  background-color: var(--color-accent, #f8f8f8);\n  transform: translateY(-50%) scale(1.05);\n}\n\n.carouselButton:active {\n  transform: translateY(-50%) scale(0.95);\n}\n\n.prevButton {\n  left: -18px;\n}\n\n.nextButton {\n  right: -18px;\n}\n\n/* Анимации для кнопок */\n@keyframes pulse {\n  0% {\n    transform: translateY(-50%) scale(1);\n  }\n  50% {\n    transform: translateY(-50%) scale(1.05);\n  }\n  100% {\n    transform: translateY(-50%) scale(1);\n  }\n}\n\n/* Медиа-запросы для адаптивности */\n@media (max-width: 768px) {\n  .carouselButton {\n    width: 30px;\n    height: 30px;\n  }\n  \n  .prevButton {\n    left: -10px;\n  }\n  \n  .nextButton {\n    right: -10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionCards": `Cards_sectionCards__rZ-xG`,
	"sectionCardsContainer": `Cards_sectionCardsContainer__1Jc7w`,
	"card": `Cards_card__ybewp`,
	"price": `Cards_price__5p-fO`,
	"carouselContainer": `Cards_carouselContainer__r7iHE`,
	"carouselViewport": `Cards_carouselViewport__Ew4wB`,
	"cardsWrapper": `Cards_cardsWrapper__tGoOy`,
	"carousel": `Cards_carousel__GZWZk`,
	"carouselCard": `Cards_carouselCard__5Mh-G`,
	"carouselButton": `Cards_carouselButton__EIxLo`,
	"prevButton": `Cards_prevButton__nmblu`,
	"nextButton": `Cards_nextButton__U9ibW`,
	"pulse": `Cards_pulse__1RqEr`
};
export default ___CSS_LOADER_EXPORT___;
